import dynamic from 'next/dynamic'

// Workaround to force Next.js to not even think about server side rendering
export default dynamic(() => import('./HeaderComponent'), {
  ssr: false,
})
